import script from "./CalendarBar.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarBar.vue?vue&type=script&setup=true&lang=js"

import "./CalendarBar.vue?vue&type=style&index=0&id=ba590738&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\GK\\MulticaseWeb\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba590738"]])

export default __exports__